import { render, staticRenderFns } from "./AgentsERP.vue?vue&type=template&id=389da5bc&scoped=true"
import script from "./AgentsERP.vue?vue&type=script&lang=js"
export * from "./AgentsERP.vue?vue&type=script&lang=js"
import style0 from "./AgentsERP.vue?vue&type=style&index=0&id=389da5bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389da5bc",
  null
  
)

export default component.exports